/*
 * @Author: mayanxia 
 * @Date: 2020-10-29 19:21:21 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2021-01-26 16:12:12
 */

<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="drawerWidth"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="height: 100%;overflow: auto;padding-bottom: 53px;">

    <template slot="title">
      <div style="width: 100%;">
        <span>{{ title }}</span>
        <span style="display:inline-block;width:calc(100% - 51px);padding-right:10px;text-align: right">
          <a-button @click="toggleScreen" icon="appstore" style="height:20px;width:20px;border:0px"></a-button>
        </span>
      </div>

    </template>

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item :label="$t('登录账号')" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input disabled :placeholder="$t('请输入登录账号')" v-decorator.trim="[ 'username', validatorRules.username]" :readOnly="!!model.id"/>
        </a-form-item>


        <a-form-item :label="$t('账号姓名')" :labelCol="labelCol" :wrapperCol="wrapperCol" >
          <a-input disabled :placeholder="$t('请输入账号姓名')" v-decorator.trim="[ 'realname', validatorRules.realname]" />
        </a-form-item>
        <a-form-item :label="$t('手机号码')" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input disabled :placeholder="$t('请输入手机号码')" v-decorator.trim="[ 'phone', validatorRules.phone]" />
        </a-form-item>

        <a-form-item :label="$t('工号')" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input disabled :placeholder="$t('请输入工号')" v-decorator.trim="[ 'workNo', validatorRules.workNo]" />
        </a-form-item>

        <!--部门分配-->
        <a-form-item :label="$t('部门分配')" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="!departDisabled">
          <a-input-search
            :placeholder="$t('点击选择部门')"
            v-model="checkedDepartNameString"
            disabled
            @search="onSearch">
            <a-button slot="enterButton" icon="search">{{ $t('选择') }}</a-button>
          </a-input-search>
        </a-form-item>
        <a-form-item :label="$t('负责部门')" :labelCol="labelCol" :wrapperCol="wrapperCol"  v-if="departIdShow==true">
          <a-select
            disabled
            mode="multiple"
            style="width: 100%"
            :placeholder="$t('请选择负责部门')"
            v-model="departIds"
            optionFilterProp = "children"
            :getPopupContainer = "(target) => target.parentNode"
            :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
          >
            <a-select-option v-for="item in resultDepartOptions" :key="item.key" :value="item.key"
            >{{item.title}}</a-select-option
            >
          </a-select>
        </a-form-item>
        <!--区域分配-->
        <a-form-item :label="$t('区域分配')" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-search
            :placeholder="$t('点击选择区域')"
            v-model="checkedAreaNameString"
            readOnly
            @search="onSearchArea">
            <a-button slot="enterButton" icon="search">{{ $t('选择') }}</a-button>
          </a-input-search>
        </a-form-item>
      </a-form>
    </a-spin>
    <depart-window ref="departWindow" @ok="modalFormOk"></depart-window>
    <area-window ref="areaWindow" @ok="modalAreaFormOk"></area-window>

    <div class="drawer-bootom-button" v-show="!disableSubmit">
      <a-popconfirm :title="$t('确定放弃编辑？')" @confirm="handleCancel" :okText="$t('确定')" :cancelText="$t('取消')">
        <a-button style="margin-right: .8rem">{{ $t('取消') }}</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit" type="primary" :loading="confirmLoading">{{ $t('提交') }}</a-button>
    </div>
  </a-drawer>
</template>

<script>
  import pick from 'lodash.pick'
  import moment from 'moment'
  import Vue from 'vue'
  // 引入搜索部门弹出框的组件
  import departWindow from './DepartWindow'
  // 引入搜索区域弹出框的组件
  import areaWindow from './areaWindow'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import { getAction,postAction } from '@/api/manage'
  import {addUser,editUser,queryUserRole,queryall } from '@/api/api'
  import { disabledAuthFilter } from "@/utils/authFilter"
  import {duplicateCheck } from '@/api/api'
  import {queryAreaTreeList} from '@/api/api'

  export default {
    name: "UserAreaAuthModal",
    components: {
      departWindow,
      areaWindow
    },
    data () {
      return {
        departDisabled: false, //是否是我的部门调用该页面
        modalWidth:800,
        drawerWidth:700,
        modaltoggleFlag:true,
        confirmDirty: false,
        selectedDepartKeys:[], //保存用户选择部门id
        checkedDepartKeys:[],
        checkedDepartNames:[], // 保存部门的名称 =>title
        checkedDepartNameString:"", // 保存部门的名称 =>title
        checkedAreaKeys:[],
        halfCheckedAreaKeys: [],
        checkedAreaNameString:"", // 保存区域的名称 =>title
        resultDepartOptions:[],
        userId:"", //保存用户id
        disableSubmit:false,
        userDepartModel:{userId:'',departIdList:[]}, // 保存SysUserDepart的用户部门中间表数据需要的对象
        dateFormat:"YYYY-MM-DD",
        validatorRules:{
        },
        departIdShow:false,
        departIds:[], //负责部门id
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        form:this.$form.createForm(this),
        url: {
            fileUpload: window._CONFIG['domianURL']+"/sys/common/upload",
            userWithDepart: "/sys/user/userDepartList", // 引入为指定用户查看部门信息需要的url
            userId:"/sys/user/generateUserId", // 引入生成添加用户情况下的url
            userWithArea: "/jeecg-charge/meter/meterArea/userAreaList", // 查询用户授权的区域列表
            userAreaAuto: "/jeecg-charge/meter/meterSysUserArea/addSysUserAreaList"
        },
        identity:"1",
        fileList:[],
        treeData: [],
        checkedAreaNames: [],

      }
    },
    created () {

    },
    computed: {
      // i18n：标题使用 computed 以响应语言切换
      title () {
        return this.$t('操作')
      },
    },
    methods: {
      //窗口最大化切换
      toggleScreen(){
        if(this.modaltoggleFlag){
          this.modalWidth = window.innerWidth;
        }else{
          this.modalWidth = 800;
        }
        this.modaltoggleFlag = !this.modaltoggleFlag;
      },
      refresh () {
          this.selectedDepartKeys=[];
          this.checkedDepartKeys=[];
          this.checkedDepartNames=[];
          this.checkedDepartNameString = "";
          this.userId=""
          this.resultDepartOptions=[];
          this.departId=[];
          this.departIdShow=false;
      },
      add () {
        this.refresh();
        this.edit({});
      },
      edit (record) {
        this.resetScreenSize(); // 调用此方法,根据屏幕宽度自适应调整抽屉的宽度
        let that = this;
        that.checkedDepartNameString = "";
        that.form.resetFields();
        that.userId = record.id;
        that.visible = true;
        that.model = Object.assign({}, record);
        this.queryAreaTree();
        that.$nextTick(() => {
          that.form.setFieldsValue(pick(this.model,'username','realname','phone','workNo'))
        });
        //身份为上级显示负责部门，否则不显示
        if(this.model.userIdentity=="2"){
            this.identity="2";
            this.departIdShow=true;
        }else{
            this.identity="1";
            this.departIdShow=false;
        }
        // 调用查询用户对应的部门信息的方法
        that.checkedDepartKeys = [];
        that.loadCheckedDeparts();
      },
      //
      loadCheckedDeparts(){
        let that = this;
        if(!that.userId){return}
        getAction(that.url.userWithDepart,{userId:that.userId}).then((res)=>{
          that.checkedDepartNames = [];
          if(res.success){
            var depart=[];
            var departId=[];
            for (let i = 0; i < res.result.length; i++) {
              that.checkedDepartNames.push(res.result[i].title);
              this.checkedDepartNameString = this.checkedDepartNames.join(",");
              that.checkedDepartKeys.push(res.result[i].key);
              //新增负责部门选择下拉框
              depart.push({
                  key:res.result[i].key,
                  title:res.result[i].title
              })
              departId.push(res.result[i].key)
            }
            that.resultDepartOptions=depart;
            //判断部门id是否存在，不存在择直接默认当前所在部门
            if(this.model.departIds){
                this.departIds=this.model.departIds.split(",");
            }else{
                this.departIds=departId;
            }
            that.userDepartModel.departIdList = that.checkedDepartKeys
          }else{
            console.log(res.message);
          }
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
        this.userDepartModel = {userId:'',departIdList:[]};
        this.checkedDepartNames = [];
        this.checkedDepartNameString='';
        this.checkedDepartKeys = [];
        this.selectedDepartKeys = [];
        this.resultDepartOptions=[];
        this.departIds=[];
        this.departIdShow=false;
        this.halfCheckedAreaKeys = [];
        this.checkedAreaKeys = [];
        this.checkedAreaNames = [],
        this.checkedAreaNameString = ''
        this.identity="1";
      },
      moment,
      handleSubmit () {

        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            if(!values.birthday){
              values.birthday = '';
            }else{
              values.birthday = values.birthday.format(this.dateFormat);
            }
            let formData = {sysUserId: this.model.username};
            formData.meterAreaId=[...this.checkedAreaKeys].join(",");
            postAction(this.url.userAreaAuto, formData).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.checkedDepartNames = [];
              that.userDepartModel.departIdList = {userId:'',departIdList:[]};
              that.close();
            })

          }
        })
      },
      handleCancel () {
        this.close()
      },
      // 搜索用户对应的部门API
      onSearch(){
        this.$refs.departWindow.add(this.checkedDepartKeys,this.userId);
      },
      // 搜索用户对应的秋雨API
      onSearchArea(){
        this.$refs.areaWindow.add(this.checkedAreaKeys,this.halfCheckedAreaKeys,this.treeData,this.checkedAreaNames,this.userId);
      },

      // 获取用户对应部门弹出框提交给返回的数据
      modalFormOk (formData) {
        this.checkedDepartNames = [];
        this.selectedDepartKeys = [];
        this.checkedDepartNameString = '';
        this.userId = formData.userId;
        this.userDepartModel.userId = formData.userId;
        this.departIds=[];
        this.resultDepartOptions=[];
        var depart=[];
        for (let i = 0; i < formData.departIdList.length; i++) {
          this.selectedDepartKeys.push(formData.departIdList[i].key);
          this.checkedDepartNames.push(formData.departIdList[i].title);
          this.checkedDepartNameString = this.checkedDepartNames.join(",");
          //新增部门选择，如果上面部门选择后不为空直接付给负责部门
          depart.push({
              key:formData.departIdList[i].key,
              title:formData.departIdList[i].title
          })
          this.departIds.push(formData.departIdList[i].key)
        }
        this.resultDepartOptions=depart;
        this.userDepartModel.departIdList = this.selectedDepartKeys;
        this.checkedDepartKeys = this.selectedDepartKeys  //更新当前的选择keys
      },
       // 获取用户对应部门弹出框提交给返回的数据
      modalAreaFormOk (formData) {
        this.checkedAreaNames = formData.areaNameList;
        this.checkedAreaNameString = this.checkedAreaNames.join(",");
        this.checkedAreaKeys = formData.checkedKeys;
        this.halfCheckedAreaKeys = formData.halfCheckedKeys;
      },
      // 根据屏幕变化,设置抽屉尺寸
      resetScreenSize(){
        let screenWidth = document.body.clientWidth;
        if(screenWidth < 500){
          this.drawerWidth = screenWidth;
        }else{
          this.drawerWidth = 700;
        }
      },
      queryAreaTree(){
        queryAreaTreeList().then((res)=>{
          // 过滤出 leaf node 即可，即选中的
          // Tree组件中checkStrictly默认为false的时候，选中子节点，父节点会自动设置选中或半选中
          // 保存 checkedKeys 以及 halfCheckedKeys 以便于未做任何操作时提交表单数据
          if(res.success){
            this.treeData = res.result;
            const keyLeafPairs = this.convertTreeListToKeyLeafPairs(this.treeData)
            getAction(this.url.userWithArea,{userId:this.model.username}).then((res) => {
              const areaNameList = []
              const checkedKeys =[]
              const halfCheckedKeys = []
              if(res.success&&res.result.length>0) {
                res.result.forEach(key => {
                  const keyLeafPair = keyLeafPairs.filter(item => item.key === key.key)[0]
                  areaNameList.push(key.title)
                  checkedKeys.push(key.key)
                })
              }
              this.checkedAreaKeys = [...checkedKeys];
              
              this.checkedAreaNames = areaNameList;
              this.checkedAreaNameString = this.checkedAreaNames.join(",");
            })
          }
        })
      },
      convertTreeListToKeyLeafPairs(treeList, keyLeafPair = []) {
        for(const {key, isLeaf, title, children} of treeList) {
          keyLeafPair.push({key, isLeaf, title})
          if(children && children.length > 0) {
            this.convertTreeListToKeyLeafPairs(children, keyLeafPair)
          }
        }
        return keyLeafPair;
      },
    }
  }
</script>

<style scoped>
  .avatar-uploader > .ant-upload {
    width:104px;
    height:104px;
  }
  .ant-upload-select-picture-card i {
    font-size: 49px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .ant-table-tbody .ant-table-row td{
    padding-top:10px;
    padding-bottom:10px;
  }

  .drawer-bootom-button {
    position: absolute;
    bottom: -8px;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>